import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.fraud');

const Fraud = () => {
  const { watch, setValue } = useFormContext();
  const excludeHighRisk = watch('excludeHighRisk');

  const buttonLabel = `${t('title')}${excludeHighRisk ? ' (1)' : ''}`;

  const clear = () => {
    setValue('excludeHighRisk', false);
  };

  return (
    <PopoverButton buttonLabel={buttonLabel} title={t('title')}>
      <Stack spacing={2} direction="column">
        <CheckboxField
          name="excludeHighRisk"
          label={t('checkbox_label')}
          value="excludeHighRisk"
        />
        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear}>{t('clear')}</TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default Fraud;
